import { render, staticRenderFns } from "./DjVueSelect.vue?vue&type=template&id=547c4b1a&scoped=true&"
import script from "./DjVueSelect.vue?vue&type=script&lang=ts&"
export * from "./DjVueSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c4b1a",
  null
  
)

export default component.exports